import ReactDOM from "react-dom";
import App from "./App";
import "aos/dist/aos.css";
import "./index.css";

ReactDOM.render(<App />, document.querySelector("#root"));
